import React, { useState, useEffect } from 'react'
import { useToasts } from 'react-toast-notifications'
import { useDispatch, useSelector } from 'react-redux'

import MainModal from '../../../../components/dashboard/modal/MainModal'
import Flex from '../../../../components/layouts/Flex'
import RichTextbox from '../../../../components/dashboard/controls/RichTextBox'
import { P } from '../../../../style/Typography.style'

import { setModal } from '../../../../store/actions/listsActions'
import { setInterviews } from '../../../../store/actions/recruitersActions'

import useMutation from '../../../../hooks/useMutation'

const WithdrawApplication = () => {
  const [reason, setReason] = useState('')
  const { addToast } = useToasts()
  const dispatch = useDispatch()
  const { selectedInterview, interviews } = useSelector(
    (state) => state.requisitions
  )

  const { data, loading, handleRequest, success, error } = useMutation()

  const handleSubmit = () => {
    if (
      reason.trim() === '' ||
      reason.trim() === '<p></p>' ||
      reason.trim() === '<p><br></p>'
    ) {
      return addToast('Please provide a reason for withdrawal.', {
        appearance: 'error',
        autoDismiss: true,
      })
    }

    handleRequest(
      `applicant/${selectedInterview.applicant_id}/withdraw`,
      {
        job_id: selectedInterview.job_id.toString(),
        reason: reason,
      },
      'PUT'
    )
  }

  // check if request was successful.
  useEffect(() => {
    if (data) {
      const filteredInterview = interviews.filter(
        (interview) => interview.id !== selectedInterview.id
      )

      dispatch(setInterviews(filteredInterview))

      addToast(data?.message, {
        appearance: 'success',
        autoDismiss: true,
      })

      dispatch(setModal(''))
    }
  }, [success])

  useEffect(() => {
    if (error) {
      addToast(
        error?.response?.data?.message ||
          error?.response?.message ||
          'Something went wrong',
        {
          appearance: 'error',
          autoDismiss: true,
        }
      )
    }
  }, [error])

  return (
    <>
      <MainModal
        title="Withdraw Application"
        buttonText="Submit"
        loading={loading}
        onClick={handleSubmit}
      >
        <Flex direction="column" gap="0.4rem" margin="1rem 0 0 0">
          <P as="label">Reason for Withdrawal</P>
          <RichTextbox content={reason} setContent={setReason} />
        </Flex>
      </MainModal>
    </>
  )
}

export default WithdrawApplication
